/* Elegancecoque - fiche produit : récapitulatif du choix (modèle et couleur) et mention quand la variante choisie n'a pas sa propre photo */
(function(){
if(window.__luxeChoice){return;}window.__luxeChoice=true;
var doc=document,MODEL='Modèle iPhone';
function box(){return doc.querySelector('[data-lmf-sum]');}
function imgs(){var n=doc.querySelector('[data-lmf-vimg]');if(!n){return {};}try{return JSON.parse(n.textContent)||{};}catch(e){return {};}}
function groups(){
 var names=[],sel={};
 [].forEach.call(doc.querySelectorAll('input[type=radio][data-option-name]'),function(r){
  var n=r.getAttribute('data-option-name');if(names.indexOf(n)<0){names.push(n);}
  if(r.checked){sel[n]=(r.value||'').trim();}
 });
 [].forEach.call(doc.querySelectorAll('select[data-option-name], select[name^="options["]'),function(s){
  var n=s.getAttribute('data-option-name')||(s.name||'').replace(/^options\[|\]$/g,'');if(!n){return;}
  if(names.indexOf(n)<0){names.push(n);}
  if(s.value){sel[n]=s.value.trim();}
 });
 return {names:names,sel:sel};
}
function variantId(){var i=doc.querySelector('form[action*="/cart/add"] input[name=id]');return i?String(i.value||''):'';}
function update(){
 var b=box();if(!b){return;}
 var g=groups();
 if(!g.names.length){b.hidden=true;return;}
 var order=g.names.slice().sort(function(a,c){return (a===MODEL?0:1)-(c===MODEL?0:1);});
 var parts=order.map(function(n){
  var v=g.sel[n];
  if(n===MODEL){return '<span class=\'lmf-sum__r\'><span class=\'lmf-sum__l\'>Modèle sélectionné :</span> '+(v?'<b>iPhone '+esc(v)+'</b>':'<span class=\'lmf-sum__todo\'>à choisir</span>')+'</span>';}
  return '<span class=\'lmf-sum__r\'><span class=\'lmf-sum__l\'>'+esc(n)+' :</span> '+(v?'<b>'+esc(v)+'</b>':'<span class=\'lmf-sum__todo\'>à choisir</span>')+'</span>';
 });
 b.querySelector('[data-lmf-sum-v]').innerHTML=parts.join('');
 b.hidden=false;
 var note=doc.querySelector('[data-lmf-photo]');
 if(note){
  var map=imgs(),id=variantId(),modelOk=g.names.indexOf(MODEL)<0||!!g.sel[MODEL];
  note.hidden=!(modelOk&&id&&map.hasOwnProperty(id)&&map[id]===false);
 }
}
function esc(t){var d=doc.createElement('span');d.textContent=t;return d.innerHTML;}
var t=0;function later(){window.clearTimeout(t);t=window.setTimeout(update,120);}
doc.addEventListener('change',later,true);
doc.addEventListener('click',later,true);
doc.addEventListener('luxe:model-cleared',later);
if(window.MutationObserver){var mo=new MutationObserver(later);var start=function(){var f=doc.querySelector('form[action*="/cart/add"]');var vp=doc.querySelector('variant-picker, .variant-picker');[f,vp].forEach(function(n){if(n){mo.observe(n,{subtree:true,attributes:true,attributeFilter:['value','checked']});}});};if(doc.readyState==='loading'){doc.addEventListener('DOMContentLoaded',start);}else{start();}}
if(doc.readyState==='loading'){doc.addEventListener('DOMContentLoaded',update);}else{update();}
window.setTimeout(update,900);window.setTimeout(update,2500);
})();
